import React from 'react'
import { Row, Typography, Card } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'

import FNOLStyle from '../../styles/FNOLClaims.module.css'

const { Link } = Typography

const FNOLResults = () => {
  return (
    <div className="container">
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Thanks for reporting your claim online!" />
        <div className={`${FNOLStyle["claims-selection"]} ${FNOLStyle["padding"]}`}>
          <Row>
            <Card className="register-card">
              <span className={`${FNOLStyle["link-text"]}`} style={{ color: 'black', marginTop: '10px' }}>
                Thank you for submitting your claim online.
              </span>
              <span className={`${FNOLStyle["link-text"]}`} style={{ color: 'black', marginTop: '10px' }}>
                You can expect to hear from your dedicated CURE Claims Representative within 1-2 business days. 
              </span>
              <span className={`${FNOLStyle["link-text"]}`} style={{ color: 'black', marginTop: '10px' }}>
                Visit our Claims Center FAQ by clicking <a href="https://www.cure.com/claims" style={{ textDecoration: 'underline', color: 'black !important', fontWeight: 400, fontStyle: 'normal' }} target="_blank" rel="noopener noreferrer">here</a>. 
              </span>
            </Card>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

FNOLResults.propTypes = {}

export default FNOLResults
